import { Construction } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';

export interface PlaceholderRouteProps {
  title: string;
  description?: string;
}

export function PlaceholderRoute({ title, description }: PlaceholderRouteProps) {
  return (
    <div className="space-y-6 p-6">
      <header>
        <h1 className="text-2xl font-bold tracking-tight">{title}</h1>
        {description && <p className="text-sm text-muted-foreground">{description}</p>}
      </header>
      <Card>
        <CardContent className="flex flex-col items-center justify-center gap-3 py-16 text-center">
          <div className="rounded-full bg-muted p-4 text-muted-foreground">
            <Construction className="h-8 w-8" />
          </div>
          <div>
            <h3 className="text-base font-semibold">Đang xây dựng</h3>
            <p className="mt-1 text-sm text-muted-foreground">
              Trang này sẽ có trong các phase tiếp theo.
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
